'use es6';

import { isApiNameOwnedAdapter } from 'self-service-api/adapters/isProductOwnedAdapter';
import PRODUCT_TIER_ORDERS from 'self-service-api/constants/ProductTierOrders';
const hasHigherTieredProductAdapter = ({
  apiName,
  ownedProducts
}) => {
  // An array of tiered apiNames for the hub your current apiName is in
  const tieredProductsGroup = PRODUCT_TIER_ORDERS.filter(productTierOrder => productTierOrder.indexOf(apiName) !== -1)[0];
  if (!tieredProductsGroup) {
    return false;
  }

  // Index of where in the tier this apiName is
  const tierIndex = tieredProductsGroup.indexOf(apiName);
  const higherTieredProductGroups = tieredProductsGroup.slice(tierIndex + 1, tieredProductsGroup.length);
  const hasHigherProduct = higherTieredProductGroups.some(tieredApiName => {
    return isApiNameOwnedAdapter(ownedProducts, tieredApiName);
  });
  return hasHigherProduct;
};
export { hasHigherTieredProductAdapter as default };